import React, { Component } from "react";
import PropTypes from "prop-types";

class ExpandablePanel extends Component {
  constructor() {
    super();
    this.onButtonPress = this.onButtonPress.bind(this);
  }
  onButtonPress(event) {
    event.stopPropagation();
    event.preventDefault();

    const { expanded, onExpandedChanged } = this.props;
    onExpandedChanged(!expanded);
  }

  render() {
    const {
      children,
      openedButtonText,
      closedButtonText,
      expanded,
      hasExpand
    } = this.props;
    return (
      <div
        className={`expandable-panel${
          hasExpand ? " expandable-panel-has-expand" : ""
        }`}
      >
        <div
          className={`expandable-panel-content expandable-panel-content${
            expanded ? "-opened" : "-closed"
          }`}
        >
          {children}
        </div>
        {hasExpand && (
          <div className="expandable-panel-footer">
            <button
              onClick={this.onButtonPress}
              className="expandable-panel-footer-button"
            >
              {expanded ? openedButtonText : closedButtonText}
            </button>
          </div>
        )}
      </div>
    );
  }
}

ExpandablePanel.defaultProps = {
  children: null,
  openedButtonText: "Show less",
  closedButtonText: "Show all"
};

ExpandablePanel.propTypes = {
  openedButtonText: PropTypes.string,
  closedButtonText: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  expanded: PropTypes.bool.isRequired,
  onExpandedChanged: PropTypes.func.isRequired,
  hasExpand: PropTypes.bool.isRequired
};

export default ExpandablePanel;
